export default __webpack_public_path__ + "media/zurb/img/home/home-service-img1-1f4ef4cb29a618623f04496b4e479cc7.png";